import { render, staticRenderFns } from "./ActualizaAspiranteDialogComponent.vue?vue&type=template&id=7aa989a0&scoped=true"
import script from "./ActualizaAspiranteDialogComponent.vue?vue&type=script&lang=js"
export * from "./ActualizaAspiranteDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./ActualizaAspiranteDialogComponent.vue?vue&type=style&index=0&id=7aa989a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa989a0",
  null
  
)

export default component.exports